import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gm',
  templateUrl: './gm.component.html',
  styleUrls: ['./gm.component.scss']
})
export class GmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
